module.exports = __webpack_public_path__ + "light-repeating2.svg?3a95156dd09eed51cbaea4306d5581b8";